export enum AssignmentTypeOptions {
  FINANCIAL_INQUIRY = '02b99be8-5615-4a20-b0e7-67b3269e5998',
  OTHER = 'b61ac07f-bd01-4e04-b348-75c9f040fdde',
  PRICE_LIST = '2327730c-b6ed-42cb-9253-834c00e6ceb8',
  BUSINESS_DEVELOPMENT = 'd5481f85-c83f-4f58-8cec-50c62e5d63e2',
}
